import { BrowserRouter, Route, Routes } from "react-router-dom";
import Success from "./components/Success";
import Home from "./components/Home";
import "@stripe/stripe-js"
import Cancel from "./components/Cancel";
import Admin from "./components/Admin";


const Routing = () => {

  return (
    <Routes>
      <Route path="/" element={<Home />}  exact >
      </Route>
      <Route path="/admin" element={<Admin />}  exact >
      </Route>
      <Route path="/success" element={<Success />}  exact >
      </Route>
      <Route path="/cancel" element={<Cancel />}  exact >
      </Route>
     
    </Routes>
  );
};


function App() {

  

  return (
    <div className="App">
      <BrowserRouter>
        
          <Routing />

      </BrowserRouter>
    </div>
  );
}

export default App;
